import UserDatabases from '@Services/UserDatabases';
import Search from '@Services/Search';

/* eslint-disable no-use-before-define */
const MULTIPLIER = 5;
const COMPLETE_PERCENT = 100;
const SWITCH_THRESHOLD = 9;

export const calculatePercentage = (runningTime) => {
  if (runningTime < SWITCH_THRESHOLD) {
    return calculateQuickPercentage(runningTime);
  }
  return calculateLongPercentage(runningTime);
};

export const calculateQuickPercentage = (runningTime) => {
  return MULTIPLIER * runningTime - Math.floor(Math.random() * MULTIPLIER);
};

export const calculateLongPercentage = (runningTime) => {
  return Math.floor((COMPLETE_PERCENT * runningTime) / (runningTime + SWITCH_THRESHOLD));
};

export const getTotalProgress = (runningTime) => {
  return calculatePercentage(runningTime);
};

export const checkIfAllSearchesFinished = (progressPercentage, cb) => {
  const isAllFinished = Object.keys(progressPercentage).every((dbId) => progressPercentage[dbId].finished);

  if (isAllFinished && cb) {
    cb();
  }
};

export const getCurrentDbName = (priorityWatcher) => {
  const dbId = priorityWatcher.getFirstNotLoaded().databaseId;
  return UserDatabases.getDbName(dbId);
};

export const cancelSearch = (searchId, requestId) => {
  Search.cancelSearch(searchId, requestId);
};
